// src/data/grammarQuestions/noticeAd2Questions.js
export const noticeAd2Questions = [
  {
    id: 1,
    koreanQuestion:
      "모든 직원들 그... 담당하는 국제 무역을 반드시 완료해야 한다 의무 교육 세션을 2025년 5월 25일까지, 보장하기 위해 완전한 _____ 개정된 정책에 대한.",
    question:
      "All employees handling international trade must complete the mandatory compliance training session by May 25, 2025, to ensure full ______ to the revised policies.",
    choices: {
      A: "attention",
      B: "invitation",
      C: "resistance",
      D: "adherence",
    },
    correctAnswer: "D",
    explanation:
      "A: attention(주의), B: invitation(초대), C: resistance(저항), D: adherence(준수). 여기서는 'adherence'가 '준수, 고수'라는 의미로 정책을 따르는 것을 나타내므로 가장 적절합니다. 직원들이 개정된 정책을 완전히 준수하도록 하기 위한 교육이라는 맥락입니다.",
    translation:
      "국제 무역을 담당하는 모든 직원들은 개정된 정책에 대한 완전한 준수를 보장하기 위해 2025년 5월 25일까지 의무적인 규정 준수 교육 세션을 완료해야 합니다.",
    type: "noun",
  },
  {
    id: 2,
    koreanQuestion: "CEO는 연설할 것입니다 주주들에게 연례 총회에서.",
    question:
      "The CEO will address shareholders ______ the annual general meeting.",
    choices: {
      A: "in",
      B: "at",
      C: "on",
      D: "by",
    },
    correctAnswer: "B",
    explanation:
      "A: in(~안에), B: at(~에서), C: on(~위에, ~에), D: by(~옆에, ~까지). 여기서는 'at'이 특정 장소나 행사에서의 위치를 나타내는 전치사로, 연례 총회라는 행사에서 연설한다는 의미를 정확히 전달합니다. 행사나 모임의 장소를 나타낼 때는 'at'을 사용합니다.",
    translation: "CEO는 연례 총회에서 주주들에게 연설할 것입니다.",
    type: "preposition",
  },
  {
    id: 3,
    koreanQuestion:
      "우리는 노력하고 있습니다 보장하는 것을 최소한의 방해를 그리고 완료할 것입니다 유지보수를 _____ 가능한.",
    question:
      "We are committed to ensuring minimal disruption and will complete the maintenance as ______ as possible.",
    choices: {
      A: "lazily",
      B: "randomly",
      C: "swiftly",
      D: "carelessly",
    },
    correctAnswer: "C",
    explanation:
      "A: lazily(게으르게), B: randomly(무작위로), C: swiftly(신속하게), D: carelessly(부주의하게). 여기서는 'swiftly'가 '신속하게, 빠르게'라는 의미로 유지보수를 가능한 한 빨리 완료하겠다는 의미를 나타내므로 가장 적절합니다. 최소한의 방해를 보장한다는 맥락에서 신속함이 중요합니다.",
    translation:
      "우리는 최소한의 방해를 보장하기 위해 노력하고 있으며 유지보수를 가능한 한 신속하게 완료할 것입니다.",
    type: "adverb",
  },
  {
    id: 4,
    koreanQuestion:
      "승인된 초과 근무는 ______ 될것입니다 1.5배로 정규 시간 당, 노동법에 따라.",
    question:
      "Approved overtime will be ______ at 1.5 times the regular hourly rate, in accordance with labor law.",
    choices: {
      A: "measured",
      B: "recorded",
      C: "compensated",
      D: "canceled",
    },
    correctAnswer: "C",
    explanation:
      "A: measured(측정된), B: recorded(기록된), C: compensated(보상된), D: canceled(취소된). 여기서는 'compensated'가 '보상된, 지급된'이라는 의미로 초과 근무에 대한 급여 지급을 나타내므로 가장 적절합니다. 초과 근무에 대해 정규 시간당 급여의 1.5배로 보상한다는 맥락입니다.",
    translation:
      "승인된 초과 근무는 노동법에 따라 정규 시간당 급여의 1.5배로 보상될 것입니다.",
    type: "verb",
  },
  {
    id: 5,
    koreanQuestion:
      "이러한 업데이트는 (현재) 만들어졌습니다 개선하기 위해 공정성, 투명성, 그리고 준수를 노동 규정과 함께.",
    question:
      "These updates have been made to improve fairness, transparency, and compliance ______ labor regulations.",
    choices: {
      A: "with",
      B: "over",
      C: "against",
      D: "through",
    },
    correctAnswer: "A",
    explanation:
      "A: with(~와 함께), B: over(~위에), C: against(~에 반대하여), D: through(~을 통해). 여기서는 'compliance with'가 '~를 준수함'이라는 의미의 관용적 표현으로, 노동 규정을 준수한다는 의미를 나타내므로 가장 적절합니다. 'Compliance'는 'with'와 함께 사용되어 규칙이나 규정을 따르는 것을 의미합니다.",
    translation:
      "이러한 업데이트는 공정성, 투명성 및 노동 규정 준수를 개선하기 위해 이루어졌습니다.",
    type: "preposition",
  },
  {
    id: 6,
    koreanQuestion:
      "기계는 ____ 조절할 것이다 온도와 압력을 제공하기 위해 완벽하게 균형 잡힌 샷을 에스프레소의.",
    question:
      "The machine will ______ adjust the temperature and pressure to deliver a perfectly balanced shot of espresso.",
    choices: {
      A: "reluctantly",
      B: "temporarily",
      C: "automatically",
      D: "aggressively",
    },
    correctAnswer: "C",
    explanation:
      "A: reluctantly(마지못해), B: temporarily(일시적으로), C: automatically(자동으로), D: aggressively(공격적으로). 여기서는 'automatically'가 '자동으로'라는 의미로 기계가 사람의 개입 없이 스스로 온도와 압력을 조절한다는 의미를 나타내므로 가장 적절합니다. 에스프레소 머신의 자동화된 기능을 설명하는 맥락입니다.",
    translation:
      "기계는 자동으로 온도와 압력을 조절하여 완벽하게 균형 잡힌 에스프레소 샷을 제공할 것입니다.",
    type: "adverb",
  },
  {
    id: 7,
    koreanQuestion:
      "감독자는 상기시킨다 직원들에게 그...____ 은 논의되는 회의에서 기밀이다 그리고 공개되어서는 안 된다 어떤 사람에게 그..  회사에 속하지 않은 사람에게",
    question:
      "The supervisor reminds the staff that ______ is discussed at the meeting is confidential and should not be revealed to anyone who is not in the company.",
    choices: {
      A: "whichever",
      B: "whatever",
      C: "whenever",
      D: "wherever",
    },
    correctAnswer: "B",
    explanation:
      "A: whichever(어느 것이든), B: whatever(무엇이든), C: whenever(언제든지), D: wherever(어디서든). 여기서는 'whatever'가 '무엇이든'이라는 의미로 회의에서 논의되는 모든 내용이 기밀이라는 의미를 나타내므로 가장 적절합니다. 'whatever is discussed'는 '논의되는 모든 것'을 의미합니다.",
    translation:
      "감독자는 직원들에게 회의에서 논의되는 모든 것은 기밀이며 회사에 속하지 않은 사람에게 공개되어서는 안 된다고 상기시킵니다.",
    type: "relative pronoun",
  },
  {
    id: 8,
    koreanQuestion:
      "사람들 그.. 도착하는 30분이상 오페라가 시작하기 전에 기다려야 한다 로비에서 메인 홀로 가는 문이 열릴 때까지",
    question:
      "People who arrive more than 30 minutes ______ the opera begins should wait in the lobby until the doors to the main hall are opened.",
    choices: {
      A: "when",
      B: "before",
      C: "since",
      D: "during",
    },
    correctAnswer: "B",
    explanation:
      "A: when(~할 때), B: before(~하기 전에), C: since(~이후로), D: during(~하는 동안). ",
    translation:
      "오페라가 시작되기 전 30분 이상 일찍 도착하는 사람들은 메인 홀로 가는 문이 열릴 때까지 로비에서 기다려야 합니다.",
    type: "preposition usage",
  },
  {
    id: 9,
    koreanQuestion:
      "직원들은 금지되어 있습니다 접근하는 것이 기밀 파일에 승인 없이 경영진으로부터의.",
    question:
      "Employees are prohibited from accessing confidential files ______ authorization from management.",
    choices: {
      A: "without",
      B: "with",
      C: "until",
      D: "despite",
    },
    correctAnswer: "A",
    explanation:
      "A: without(~없이), B: with(~와 함께), C: until(~까지), D: despite(~에도 불구하고). 여기서는 'without'이 '~없이'라는 의미로 직원들이 경영진의 승인 없이 기밀 파일에 접근하는 것이 금지되어 있다는 의미를 정확히 전달합니다.",
    translation:
      "직원들은 경영진의 승인 없이 기밀 파일에 접근하는 것이 금지되어 있습니다.",
    type: "preposition usage",
  },
  {
    id: 10,
    koreanQuestion:
      "참석자들은 컨퍼런스 그.. 원하는 머물기를 행사장 근처에 ______ 예약하도록 참석자들의 호텔을 일찍.",
    question:
      "Attendees of the conference who wish to stay near the venue are ______ to book their hotel early.",
    choices: {
      A: "advising",
      B: "advice",
      C: "advised",
      D: "advisory",
    },
    correctAnswer: "C",
    explanation:
      "A: advising(조언하는), B: advice(조언, 명사), C: advised(조언받은, 권고받은), D: advisory(자문의, 형용사). ",
    translation:
      "컨퍼런스 참석자 중 행사장 근처에 머물기를 원하는 사람들은 호텔을 일찍 예약하도록 권고받습니다.",
    type: "passive voice",
  },
  {
    id: 11,
    koreanQuestion:
      "사라 파텔은 첫 번째 ______ 입니다 받은 국립 도서상과 퓰리처상 모두를.",
    question:
      "Sarah Patel is the first ____ ever to receive both the National Book Award and the Pulitzer Prize.",
    choices: {
      A: "author",
      B: "authorship",
      C: "authored",
      D: "authoring",
    },
    correctAnswer: "A",
    explanation:
      "A: author(작가), B: authorship(저작권, 작가 신분), C: authored(저술한, 과거분사), D: authoring(저술하는 중인, 현재분사). 여기서는 명사 'author'가 필요합니다.",
    translation:
      "사라 파텔은 국립 도서상과 퓰리처상을 모두 받은 최초의 작가입니다.",
    type: "noun usage",
  },
  {
    id: 12,
    koreanQuestion:
      "스카이 타워 ______ AW 빌딩은 수용할 예정이다 새로운 지역 사무소를 Jacob and Associates의.",
    question:
      "Sky Tower ______ the AW building is going to house the new regional office of Jacob and Associates.",
    choices: {
      A: "yet",
      B: "and",
      C: "neither",
      D: "or",
    },
    correctAnswer: "D",
    explanation:
      "A: yet(아직), B: and(그리고), C: neither(둘 다 아닌), D: or(또는). 이 문맥에서는 두 건물 중 하나가 사무소를 수용할 것이므로 'or'가 적절합니다.",
    translation:
      "스카이 타워 또는 AW 빌딩은 Jacob and Associates의 새로운 지역 사무소를 수용할 예정입니다.",
    type: "conjunction",
  },
  {
    id: 13,
    koreanQuestion:
      "당신의 신청이 거부된다면, 당신은 받을 것입니다 전액 환불을 신청 수수료의.",
    question:
      "______ your application be denied, you will receive a full refund of the application fee.",
    choices: {
      A: "had",
      B: "should",
      C: "did",
      D: "might",
    },
    correctAnswer: "B",
    explanation:
      "A: had(~했었다), B: should(~해야 한다, 만약 ~한다면), C: did(했다), D: might(~할지도 모른다). 이 문맥에서는 가정법 도치 구문으로, 'If your application should be denied'를 'Should your application be denied'로 표현한 것입니다. 따라서 'should'가 정답입니다.",
    translation:
      "만약 당신의 신청이 거부된다면, 당신은 신청 수수료를 전액 환불받을 것입니다.",
    type: "conditional inversion",
  },
  {
    id: 14,
    koreanQuestion:
      "눈 폭풍이 ______ 얼어붙는 비에 의해 (현재) 예보되었습니다 중서부 지역에 일요일 저녁에.",
    question:
      "A snowstorm ______ by freezing rain has been forecast in the Midwest on Sunday evening.",
    choices: {
      A: "accompanied",
      B: "accompanying",
      C: "to accompany",
      D: "will accompany",
    },
    correctAnswer: "B",
    explanation:
      "A: accompanied(동반된), B: accompanying(동반하는), C: to accompany(동반하기 위해), D: will accompany(동반할 것이다). 이 문맥에서는 'A snowstorm'을 수식하는 분사구가 필요합니다. 'accompanied'는 수동태 과거분사로 '동반된'의 의미이고, 'accompanying'은 현재분사로 '동반하는'의 의미입니다. 여기서는 눈 폭풍이 얼어붙는 비를 동반하는 것이므로 능동의 의미를 가진 현재분사 'accompanying'이 적절합니다.",
    translation:
      "얼어붙는 비를 동반하는 눈 폭풍이 일요일 저녁 중서부 지역에 예보되었습니다.",
    type: "participle usage",
  },
  {
    id: 15,
    koreanQuestion:
      "집주인은 주장했다 그... 세입자들이 ______ 월말까지 준수하기 위해 계약을.",
    question:
      "The landlord insisted that the tenants ______ until the end of the month to abide by the contract.",
    choices: {
      A: "stay",
      B: "stayed",
      C: "will stay",
      D: "is staying",
    },
    correctAnswer: "A",
    explanation:
      "A: stay(머물다), B: stayed(머물렀다), C: will stay(머물 것이다), D: is staying(머물고 있다). 이 문장은 'insist that + 주어 + (should) 동사원형'의 형태로, 주장하다/고집하다 뒤에 오는 that절에서는 가정법 현재가 사용됩니다. 따라서 동사원형인 'stay'가 정답입니다. 'stayed'는 과거형이고, 'will stay'는 미래형이며, 'is staying'은 현재진행형으로 모두 가정법 현재 구문에 맞지 않습니다.",
    translation:
      "집주인은 세입자들이 계약을 준수하기 위해 월말까지 머물 것을 주장했습니다.",
    type: "subjunctive mood",
  },
  {
    id: 16,
    koreanQuestion:
      "직원들은 반드시 재택근무해야 합니다 ______ 다음 주 사무실 리모델링.",
    question:
      "Employees must work from home ______ office renovation next week.",
    choices: {
      A: "because of",
      B: "despite",
      C: "if",
      D: "until",
    },
    correctAnswer: "A",
    explanation:
      "A: because of(~때문에), B: despite(~에도 불구하고), C: if(만약 ~라면), D: until(~까지). 이 문맥에서는 '사무실 리모델링 때문에' 직원들이 재택근무를 해야 한다는 의미가 적절합니다. 따라서 이유를 나타내는 전치사구 'because of'가 정답입니다.",
    translation:
      "직원들은 다음 주 사무실 리모델링 때문에 반드시 재택근무해야 합니다.",
    type: "preposition usage",
  },
  {
    id: 17,
    koreanQuestion:
      "모든 직원들은 ______ 제출하도록 휴가 요청서를 최소 3주 전에.",
    question:
      "All employees are ______ to file leave requests at least three weeks in advance.",
    choices: {
      A: "remind",
      B: "reminding",
      C: "reminded",
      D: "reminder",
    },
    correctAnswer: "C",
    explanation:
      "A: remind(상기시키다), B: reminding(상기시키는 중), C: reminded(상기된, 상기시켜진), D: reminder(알림, 상기시키는 것). ",
    translation:
      "모든 직원들은 휴가 요청서를 최소 3주 전에 제출하도록 상기됩니다.",
    type: "passive voice",
  },
  {
    id: 18,
    koreanQuestion:
      "이사회는 개최할 예정이다 중요한 회의를 합병 계약에 관한 내일 결정하기 위해 ______ 수정되어야 하는지 계약서가 사인되기 전에.",
    question:
      "The board of directors will be holding an important meeting regarding the merger agreement tomorrow to decide ______ needs to be revised before it is signed.",
    choices: {
      A: "those",
      B: "that",
      C: "what",
      D: "there",
    },
    correctAnswer: "C",
    explanation:
      "A: those(그것들), B: that(그것), C: what(무엇이), D: there(거기에). 여기서는 'what'(무엇이)이 문맥상 가장 적절합니다. 'decide what needs to be revised'는 '무엇이 수정되어야 하는지 결정하다'라는 의미로, 간접의문문을 이끄는 의문사 'what'이 필요합니다.",
    translation:
      "이사회는 내일 합병 계약에 관한 중요한 회의를 개최하여 서명되기 전에 무엇이 수정되어야 하는지 결정할 예정입니다.",
    type: "noun clause",
  },
  {
    id: 19,
    koreanQuestion:
      "직원들 그... 의도하는 받으려고 면접을 전근을 위해 지원해야 합니다 오늘.",
    question:
      "The employees ______ intend to undergo an interview for transfer have to apply today.",
    choices: {
      A: "where",
      B: "when",
      C: "whose",
      D: "who",
    },
    correctAnswer: "D",
    explanation:
      "A: where(어디에), B: when(언제), C: whose(누구의), D: who(누구가). 여기서는 'who'(누구가)가 문맥상 가장 적절합니다. 'The employees who intend to...'는 '~하려는 의도가 있는 직원들'이라는 의미로, 선행사인 'employees'를 수식하는 주격 관계대명사 'who'가 필요합니다.",
    translation: "전근을 위한 면접을 받으려는 직원들은 오늘 지원해야 합니다.",
    type: "relative clause",
  },
  {
    id: 20,
    koreanQuestion:
      "이것은 필수적입니다 그...관리자들이 ______ 진행보고서를 매주 말에.",
    question:
      "It is imperative that managers ______ progress reports at the end of every week.",
    choices: {
      A: "wrote",
      B: "will write",
      C: "write",
      D: "is writing",
    },
    correctAnswer: "C",
    explanation:
      "A: wrote(과거형), B: will write(미래형), C: write(원형), D: is writing(현재진행형). 여기서는 'write'(원형)가 문맥상 가장 적절합니다. 'It is imperative that + 주어 + 동사원형'은 '~하는 것이 필수적이다'라는 의미의 가정법 현재 구문으로, 동사는 원형을 사용합니다. 물론 해석사응로도 '관리자들이 작성하는것이 진행보고서를'이 자연스럽습니다.",
    translation:
      "관리자들이 매주 말에 진행 보고서를 작성하는 것이 필수적입니다.",
    type: "subjunctive mood",
  },
  {
    id: 21,
    koreanQuestion:
      "이 독점적인 클럽은 부여하지 않을 것입니다 멤버십을 누구에게도 지원자들이 추천되지 않는 한 현재 클럽 회원에 의해",
    question:
      "This exclusive club will not grant memberships to anyone ______ applicants are recommended by a current club member.",
    choices: {
      A: "except for",
      B: "unless",
      C: "or else",
      D: "but",
    },
    correctAnswer: "B",
    explanation:
      "A: except for(~을 제외하고), B: unless(~하지 않는 한), C: or else(그렇지 않으면), D: but(그러나). 여기서는 'unless'가 정답입니다. 'unless'는 '~하지 않는 한'이라는 의미의 접속사로, 조건을 나타냅니다. 이 문장에서는 '지원자가 현재 클럽 회원에 의해 추천되지 않는 한, 이 클럽은 누구에게도 회원 자격을 부여하지 않을 것'이라는 의미가 됩니다.",
    translation:
      "이 독점적인 클럽은 지원자가 현재 클럽 회원에 의해 추천되지 않는 한 누구에게도 회원 자격을 부여하지 않을 것입니다.",
    type: "conditional",
  },
  {
    id: 22,
    koreanQuestion:
      "만약 존스씨가 ____ 한다면 회계 관리자 직책을 다른 회사로부터, 파이크씨는 되었을 것입니다 회계 관리자가 이미",
    question:
      "If Mr. Jones ______ the accounting manager position from another company, Ms. Pike would have been the accounting manager already.",
    choices: {
      A: "accepts",
      B: "will accept",
      C: "have accepted",
      D: "had accepted",
    },
    correctAnswer: "D",
    explanation:
      "만약 존슨씨가 (과거에) 받았다면 회계 관리자 직책을 다른 회사로부터, 파이크씨가 회계관리자가 되었을 것",
    translation:
      "만약 존스씨가 다른 회사에서 회계 관리자 직책을 수락했었더라면, 파이크씨는 이미 회계 관리자가 되었을 것입니다.",
    type: "conditional",
  },
  {
    id: 23,
    koreanQuestion:
      "패널은 그.. 구성된 다섯 명의 학자로 ______ 검토하기 위해 제안서를.",
    question:
      "The panel composed of five scholars ______ to review the proposal.",
    choices: {
      A: "commissions",
      B: "are commissioned",
      C: "is commissioned",
      D: "will commission",
    },
    correctAnswer: "C",
    explanation:
      "A: commissions(위임하다) - 패널이 다른 사람을 위임하는 것이므로 틀림, B: are commissioned(위임받다) - 복수형 동사인데 'panel'은 단수 주어임, C: is commissioned(위임받다) - 단수 주어 'panel'에 맞는 단수형 수동태 동사, D: will commission(위임할 것이다) - 패널이 다른 사람을 위임하는 미래형이므로 틀림. 여기서는 'panel'이라는 단수 주어에 맞는 단수형 수동태 동사 'is commissioned'가 정답입니다.",
    translation:
      "다섯 명의 학자로 구성된 패널은 제안서를 검토하기 위해 위임받았습니다.",
    type: "passive voice",
  },
  {
    id: 24,
    koreanQuestion:
      "지난주에, 관리자는 보냈습니다 메모를 요청하는 그..모든 직원들이 반드시 보내야 한다는 그들의 세금 서류를 회계 부서에 이번 주말까지, ______ 많은 직원들이 놓쳤습니다. 마감일을",
    question:
      "Last week, the manager sent a memo requesting all the workers must send their tax documents to the accounting department by the end of this week, ______ many of them missed the deadline.",
    choices: {
      A: "either",
      B: "yet",
      C: "by",
      D: "so",
    },
    correctAnswer: "B",
    explanation:
      "A: either(둘 중 하나), B: yet(그러나, 아직), C: by(~까지, ~에 의해), D: so(그래서, 매우). 여기서는 'yet'이 정답입니다. 'yet'은 '그러나, 그럼에도 불구하고'라는 의미로 앞뒤 문장의 대조적인 내용을 연결합니다. 관리자가 세금 서류를 제출하라고 요청했음에도 불구하고 많은 직원들이 마감일을 놓쳤다는 대조적인 상황을 나타냅니다.",
    translation:
      "지난주에, 관리자는 모든 직원들이 이번 주말까지 회계 부서에 세금 서류를 보내야 한다고 요청하는 메모를 보냈지만, 많은 직원들이 마감일을 놓쳤습니다.",
    type: "conjunction",
  },
  {
    id: 25,
    koreanQuestion:
      "만약 당신이 맞출 수 없다면 프로젝트의 마감일을, _______ 연장을 매니저로부터 3일 전에.",
    question:
      "If you are not able to meet the project's deadline, ______ an extension from your manager three days ahead.",
    choices: {
      A: "request",
      B: "requestes",
      C: "requsted",
      D: "requseting",
    },
    correctAnswer: "A",
    explanation:
      "명령문에서는 동사 원형을 사용합니다. 'request'는 '요청하다'라는 의미의 동사 원형입니다. 'requestes'는 철자가 잘못되었고, 'requsted'와 'requseting'도 철자가 잘못되었습니다(올바른 철자는 'requested'와 'requesting'입니다).",
    translation:
      "만약 당신이 프로젝트 마감일을 맞출 수 없다면, 매니저로부터 3일 전에 연장을 요청하세요.",
    type: "imperative",
  },
  {
    id: 26,
    koreanQuestion:
      "시행은 직장 흡연 금지 중요합니다 ______ 비흡연 근로자들을 들이마시는 것으로부터 간접 흡연을.",
    question:
      "The implementation of the workplace smoking ban is crucial in ______ non-smoking workers from breathing in secondhand smoke.",
    choices: {
      A: "preventing",
      B: "prevent",
      C: "to prevent",
      D: "prevention",
    },
    correctAnswer: "A",
    explanation:
      "시행은 중요하다 방지하는 데 비흡연 글로자들이 들이마시는 것으로부터 ",
    translation:
      "직장 내 흡연 금지 정책의 시행은 비흡연 근로자들이 간접 흡연을 들이마시는 것을 방지하는 데 중요합니다.",
    type: "gerund",
  },
  {
    id: 27,
    koreanQuestion:
      "회계사는 ______ 그.. 출장 경비가 그..청구된 영업팀에 의해 유효하지 않으며 그리고 환급되지 않을 것이라고.",
    question:
      "The accountant ______ that the travel expenses claimed by the sales team were invalid and would not be reimbursed.",
    choices: {
      A: "affirmed",
      B: "have affirmed",
      C: "affirms",
      D: "will affirm",
    },
    correctAnswer: "A",
    explanation:
      "A: affirmed(확언했다, 과거형), B: have affirmed(확언해왔다, 현재완료), C: affirms(확언한다, 현재형), D: will affirm(확언할 것이다, 미래형). 문맥상 과거에 일어난 일을 설명하고 있으므로 과거형인 'affirmed'가 정답입니다. 'were invalid'와 'would not be reimbursed'와 같은 과거형 표현들과 시제가 일치합니다.",
    translation:
      "회계사는 영업팀이 청구한 출장 경비가 유효하지 않으며 환급되지 않을 것이라고 확언했다.",
    type: "tense",
  },
  {
    id: 28,
    koreanQuestion:
      "CEO는 생각한다 그것이 필수적이라고 직원들이 ______ 정기적으로 보장하기 위해 그들의 업무가 최고 품질이며 그리고 준수하도록 규정을",
    question:
      "The CEO thinks is it imperative that employees ______ regularly to ensure their work is of the highest quality and conforms to the regulations.",
    choices: {
      A: "instruct",
      B: "be instructed",
      C: "instuction",
      D: "instructed",
    },
    correctAnswer: "B",
    explanation:
      "주어진 문장은 가정법 현재 구문으로, 'it is imperative that + 주어 + (should) 동사원형'의 형태를 취합니다. 'be instructed'는 수동태 형태의 동사원형으로, '지시를 받다'라는 의미입니다. 'instruct'는 능동태 형태로 적절하지 않고, 'instuction'은 철자가 잘못된 명사이며, 'instructed'는 과거형/과거분사로 이 구문에 맞지 않습니다.",
    translation:
      "CEO는 직원들이 그들의 업무가 최고 품질이며 규정을 준수하도록 보장하기 위해 정기적으로 지시를 받는 것이 필수적이라고 생각합니다.",
    type: "subjunctive",
  },
  {
    id: 29,
    koreanQuestion:
      "모든 판매 직원들은 요청받았다 ______ 고객 관계 워크샵에, 그.. 개최될 예정인 8월 14일 오후 3시에.",
    question:
      "All sales clerks are asked ______ in a customer relations workshop, which will be held on August 14 at 3 P.M.",
    choices: {
      A: "participate",
      B: "to participate",
      C: "participating",
      D: "participation",
    },
    correctAnswer: "B",
    explanation:
      "A: participate(참여하다, 동사원형) B: to participate(참여하기 위해, 부정사) C: participating(참여하는, 현재분사) D: participation(참여, 명사). 'ask someone to do something'은 '누군가에게 무언가를 하도록 요청하다'라는 의미의 구문으로, 부정사(to participate)가 적절합니다.",
    translation:
      "모든 판매 직원들은 8월 14일 오후 3시에 개최될 고객 관계 워크샵에 참여하도록 요청받았습니다.",
    type: "infinitive",
  },
  {
    id: 30,
    koreanQuestion:
      "작업자들은 창고 안에 상기된다 그 ... ______은 나가는 창고를 마지막으로 잠가야 한다 정문을 그리고 켜야 한다 경보 시스템을.",
    question:
      "Workers in the warehouse are reminded that ______ exits the warehouse last needs to lock the main entrance door and turn on the alarm system.",
    choices: {
      A: "anyone",
      B: "someone",
      C: "whomever",
      D: "whoever",
    },
    correctAnswer: "D",
    explanation:
      "A: anyone(누구나) B: someone(누군가) C: whomever(누구에게든지, 목적격 관계대명사) D: whoever(누구든지, 주격 관계대명사). 여기서는 '마지막으로 나가는 사람이 누구든지'라는 의미로 주어 역할을 하는 관계대명사가 필요하므로 'whoever'가 정답입니다. 'whoever'는 '~하는 사람은 누구든지'라는 의미의 주격 관계대명사로, 뒤에 완전한 절이 이어집니다.",
    translation:
      "창고의 작업자들은 창고를 마지막으로 나가는 사람이 누구든지 정문을 잠그고 경보 시스템을 켜야 한다는 것을 상기시켜집니다.",
    type: "relative pronoun",
  },
  {
    id: 31,
    koreanQuestion:
      "모든 신규 채용 직원들은 요구됩니다 작성하도록 개인 정보 양식을, 사본 그... ______ 계약서에.",
    question:
      "All newly hired employees are required to fill out the personal information form, a copy of which ______ to the contract.",
    choices: {
      A: "attach",
      B: "is attached",
      C: "is attaching",
      D: "attachement",
    },
    correctAnswer: "B",
    explanation:
      "A: attach(부착하다, 동사원형) B: is attached(부착되다, 수동태) C: is attaching(부착하고 있다, 현재진행형 수동태) D: attachement(첨부물, 명사). 여기서는 'a copy of which'가 관계대명사절의 주어이고, 계약서에 첨부되는 상황이므로 수동태인 'is attached'가 정답입니다. 'which'는 앞의 'a copy'를 가리키는 관계대명사로 사용되었습니다.",
    translation:
      "모든 신규 채용 직원들은 개인 정보 양식을 작성해야 하며, 그 사본은 계약서에 첨부됩니다.",
    type: "passive voice",
  },
  {
    id: 32,
    koreanQuestion:
      "참가자들은 알려졌다 그... 비용이 3일간의 컨퍼런스 ______ 숙박, 참고 자료, 그리고 식사를.",
    question:
      "Participants were informed that the fees for the three-day conference ______ accommodation, reference materials, and meals.",
    choices: {
      A: "to cover",
      B: "is covered",
      C: "cover",
      D: "are covered",
    },
    correctAnswer: "C",
    explanation:
      "A: to cover(~하기 위해, 부정사) B: is covered(커버된다, 단수 수동태) C: cover(커버하다, 동사원형) D: are covered(커버된다, 복수 수동태). 여기서는 주어가 'the fees'로 복수이고, 'fees'가 'accommodation, reference materials, and meals'를 포함한다는 의미이므로 복수 동사 'cover'가 정답입니다. 'fees cover something'은 '비용이 ~를 포함한다'는 의미입니다.",
    translation:
      "참가자들은 3일간의 컨퍼런스 비용이 숙박, 참고 자료, 그리고 식사를 포함한다고 알려졌습니다.",
    type: "verb agreement",
  },
  {
    id: 33,
    koreanQuestion:
      "최고 팀은 이달의 상 수여될 것이다 ____ 팀에게 영업 담당자 그 (현재) 판매했던 가장 많은 수의 제품을 올해.",
    question:
      "The Best Team of the Month Award will be given to ______ team of sales representatives has sold the highest number of products this year.",
    choices: {
      A: "whoever",
      B: "which",
      C: "some",
      D: "whichever",
    },
    correctAnswer: "D",
    explanation:
      "A: whoever(누구든지, 사람에 대한 관계대명사) B: which(~인 것, 사물에 대한 관계대명사) C: some(일부, 몇몇의) D: whichever(어느 것이든, 무엇이든). 여기서는 '어떤 팀이든 가장 많은 제품을 판매한 팀'이라는 의미로 'whichever'가 정답입니다. 'whichever'는 '어느 것이든'이라는 의미로, 여러 팀 중에서 조건을 충족하는 하나를 지칭할 때 사용됩니다.",
    translation:
      "이달의 최고 팀 상은 올해 가장 많은 제품을 판매한 영업 담당자 팀에게 수여될 것입니다.",
    type: "relative pronoun",
  },
  {
    id: 34,
    koreanQuestion:
      "투자할 때 주식에, ______ 필요한 예방 조치를 피하기 위해 오도를 시장 소문에 의한.",
    question:
      "When investing in stock, ______ necessary precautions to avoid being misled by market rumors.",
    choices: {
      A: "taking",
      B: "take",
      C: "to take",
      D: "takes",
    },
    correctAnswer: "B",
    explanation:
      "A: taking(현재분사) B: take(원형동사) C: to take(부정사) D: takes(3인칭 단수 현재형). 여기서는 명령문 형태로 '~하세요'라는 의미를 나타내므로 동사 원형인 'take'가 정답입니다. 'When investing in stock, take necessary precautions...'는 '주식에 투자할 때, 필요한 예방 조치를 취하세요'라는 의미입니다.",
    translation:
      "주식에 투자할 때, 시장 소문에 오도되지 않기 위해 필요한 예방 조치를 취하세요.",
    type: "imperative",
  },
  {
    id: 35,
    koreanQuestion:
      "______ 인턴들을 합리적인 해결책입니다 채우기 위해 초급 직위를 결국 로열 뱅크에서.",
    question:
      "______ interns is a sensible solution to filling entry-level positions eventually at Royal Bank.",
    choices: {
      A: "Recruits",
      B: "Recruit",
      C: "Recruiting",
      D: "To recruiting",
    },
    correctAnswer: "C",
    explanation:
      "A: recruits(명사 복수형 또는 3인칭 단수 동사) B: recruit(동사 원형) C: recruiting(동명사) D: to recruiting(부정사+동명사). 여기서는 문장의 주어 역할을 하는 동명사가 필요하므로 'recruiting'이 정답입니다. 'Recruiting interns is...'는 '인턴을 모집하는 것은...'이라는 의미로, 동명사구가 주어로 사용되었습니다.",
    translation:
      "로열 뱅크에서 인턴을 모집하는 것은 결국 초급 직위를 채우기 위한 합리적인 해결책입니다.",
    type: "gerund",
  },
  {
    id: 36,
    koreanQuestion:
      "구직 지원자들 그.. ______ 기술을 유용한 지원한 직책을 위한 가질 것입니다 더 나은 기회를 채용될.",
    question:
      "Job applicants _______ skills useful for the applied position will have a better chance of being hired.",
    choices: {
      A: "possessed",
      B: "possessing",
      C: "possess",
      D: "posesses",
    },
    correctAnswer: "B",
    explanation:
      "A: possessed(과거형/과거분사) B: possessing(현재분사) C: possess(동사 원형) D: posesses(철자 오류, 올바른 철자는 'possesses'로 3인칭 단수 현재형). 여기서는 'Job applicants'를 수식하는 현재분사가 필요하므로 'possessing'이 정답입니다. 'Job applicants possessing skills...'는 '기술을 보유하고 있는 구직 지원자들...'이라는 의미로, 현재분사가 명사를 수식하는 형태입니다.",
    translation:
      "지원한 직책에 유용한 기술을 보유하고 있는 구직 지원자들은 채용될 더 나은 기회를 가질 것입니다.",
    type: "participle",
  },
  {
    id: 37,
    koreanQuestion:
      "NYC 자동차 정비소는 요구합니다 정비사들에게 연락하도록 관리자들에게 즉시 만약 그들이 ______ 어떤 징후를 마모 가장자리에서 벨트",
    question:
      "NYC Auto shop requires mechanics to contact a supervisor immediately if they ______ any signs of wear on edges of the belt.",
    choices: {
      A: "are noticed",
      B: "will notice",
      C: "noticed",
      D: "notice",
    },
    correctAnswer: "D",
    explanation:
      "'만약 그들이 (현재) 발견하면 어떤 징후를' 이 되어야 하므로 현재시제가 옵니다.",
    translation:
      "NYC 자동차 정비소는 정비사들에게 벨트 가장자리에서 어떤 마모 징후라도 발견하면 즉시 감독자에게 연락하도록 요구합니다.",
    type: "conditional",
  },
  {
    id: 38,
    koreanQuestion:
      "승객들은 요청받습니다 앉아있도록 안전벨트 표시등이 꺼질 때까지.",
    question:
      "Passengers are asked to remain seated ______ the seatbelt light has been switched off.",
    choices: {
      A: "during",
      B: "whether",
      C: "until",
      D: "although",
    },
    correctAnswer: "C",
    explanation:
      "A: during(~동안에) B: whether(~인지 아닌지) C: until(~까지) D: although(비록 ~일지라도). 여기서는 '안전벨트 표시등이 꺼질 때까지' 착석해 있어야 한다는 의미이므로 'until'이 정답입니다. 'until'은 '~할 때까지'라는 의미로 시간적 한계를 나타내는 접속사입니다.",
    translation:
      "승객들은 안전벨트 표시등이 꺼질 때까지 착석해 있도록 요청받습니다.",
    type: "conjunction",
  },
  {
    id: 39,
    koreanQuestion:
      "세입자들은 그.. 계획인 리모델링할 임대 아파트를 확인해야 합니다 그.. 변경사항들이 그.. 그들이 만든 ______  관련 조항에 임대 계약서의.",
    question:
      "Tenants planning on renovating the rented apartments must make sure that the changes they make ______ to the relevant clauses of the lease contracts.",
    choices: {
      A: "adheres",
      B: "is adhered",
      C: "are adhered",
      D: "adhere",
    },
    correctAnswer: "D",
    explanation:
      "'그 변경사항들이 (현재)준수하는지 관련 조항에'가 되어야 하므로 D가 답입니다. ",
    translation:
      "임대 아파트를 리모델링할 계획인 세입자들은 그들이 하는 변경사항이 임대 계약서의 관련 조항을 준수하는지 확인해야 합니다.",
    type: "subject-verb agreement",
  },
  {
    id: 40,
    koreanQuestion:
      "고려하여 그.. 지출 삭감이 시행될 예정인 다음달에, 최고 경영자는 권고한다 모든 직원들에게 그... 그들이 제한해야 한다고 그들의 요청을 사무용품.",
    question:
      "Considering that expenditure cuts will be taking effect next month, the chief executive advises all personnel ______ they should limit their requests for office supplies.",
    choices: {
      A: "that",
      B: "if",
      C: "on",
      D: "to",
    },
    correctAnswer: "A",
    explanation:
      "A: that(~라고, ~하는 것을) B: if(만약 ~라면) C: on(~에) D: to(~에게, ~하기 위해). 여기서는 'advise + 목적어 + that절'의 구조로, 최고 경영자가 직원들에게 '~해야 한다고' 조언하는 내용이므로 'that'이 정답입니다. 'advise that'은 '~라고 조언하다'라는 의미의 표현입니다.",
    translation:
      "지출 삭감이 다음 달에 시행될 것을 고려하여, 최고 경영자는 모든 직원들에게 사무용품 요청을 제한해야 한다고 조언합니다.",
    type: "conjunction",
  },
  {
    id: 41,
    koreanQuestion:
      "만약 관리자가 허용했다면 직원들이 재택근무를 하도록, 가능성이 높습니다 그.. 회사가 ______ 사무실 비용을.",
    question:
      "If the manager allowed employees to work from home, it is likely that the company  ______ on office expenses.",
    choices: {
      A: "have saved",
      B: "would save",
      C: "saved",
      D: "save",
    },
    correctAnswer: "B",
    explanation:
      "'그 회사가 절약했을 것입니다 사무실 비용을' 이것이 결론으로 답은 B가 옵니다.",
    translation:
      "만약 관리자가 직원들이 재택근무를 하도록 허용했다면, 회사가 사무실 비용을 절약했을 가능성이 높습니다.",
    type: "conditional",
  },
  {
    id: 42,
    koreanQuestion: "공지가 새로운 안전 규정에 대한  ______  생산 시설에.",
    question:
      "An announcement about the new safety regulations ______ in the production facility.",
    choices: {
      A: "were posted",
      B: "have posted",
      C: "will be posted",
      D: "to post",
    },
    correctAnswer: "C",
    explanation:
      "'공지가 (미래에) 공지 될 것이다' 이말이 결론이므로 정답은 C입니다.",
    translation:
      "새로운 안전 규정에 대한 공지가 생산 시설에 게시될 예정입니다.",
    type: "passive voice",
  },
  {
    id: 43,
    koreanQuestion:
      "각 세미나마다, 학생들은 등록해야 합니다 그리고 지불해야 합니다 등록 날짜 전에 그.. 세미나가 시작하는.",
    question:
      "For each seminar, students have to register and pay before the registration date ______ the seminar begins.",
    choices: {
      A: "which",
      B: "on which",
      C: "on when",
      D: "in which",
    },
    correctAnswer: "B",
    explanation:
      "'the date on which'는 '~하는 날짜에'라는 의미로, 세미나가 시작하는 특정 날짜를 가리킵니다. 'on'은 날짜와 함께 사용되는 적절한 전치사입니다.",
    translation:
      "각 세미나마다, 학생들은 세미나가 시작하는 등록 날짜 전에 등록하고 지불해야 합니다.",
    type: "relative clause",
  },
  {
    id: 44,
    koreanQuestion:
      "고객들은 구매할 수 있습니다 최신 소설을  J. K. 롤링의 주문하거나 온라인으로 또는 방문함으로써 서점을.",
    question:
      "Customers may purchase the latest novel of J. K. Rowling either by ordering it online ______ visiting a bookstore.",
    choices: {
      A: "nor",
      B: "plus",
      C: "or",
      D: "yet",
    },
    correctAnswer: "C",
    explanation:
      "A: '~도 아니다'라는 부정의 의미를 가진 접속사로, 'neither...nor' 구조에서 사용됩니다. B: '더하여, 게다가'라는 의미의 전치사로, 이 문맥에서는 적절하지 않습니다. C: '또는, ~이나'라는 의미의 접속사로, 'either...or' 구조에서 사용됩니다. D: '그러나, 아직'이라는 의미의 접속사로, 이 문맥에서는 적절하지 않습니다.",
    translation:
      "고객들은 온라인으로 주문하거나 서점을 방문함으로써 J. K. 롤링의 최신 소설을 구매할 수 있습니다.",
    type: "conjunction",
  },
  {
    id: 45,
    koreanQuestion:
      "고객들은 들었습니다 그... 예약이 안될 수 있다고 주말 밤에는 레스토랑이 너무 바빴기때문에.",
    question:
      "The customers were told that no reservations could ______ on weekend nights because the restaurant was too busy.",
    choices: {
      A: "will be made",
      B: "make",
      C: "be made",
      D: "makes",
    },
    correctAnswer: "C",
    explanation:
      "no 가 나오면 뒤의 동사를 부정합니다. no reservations could be made 예약이 안될 수 있다",
    translation:
      "고객들은 레스토랑이 너무 바빠서 주말 밤에는 예약을 할 수 없다고 들었습니다.",
    type: "passive voice",
  },
  {
    id: 46,
    koreanQuestion: "기차는 항상 ______ 정시에, 지역과는 달리, 그...항상 늦는.",
    question:
      "The train always ______ on time, unlike the local, which is always late.",
    choices: {
      A: "is arriving",
      B: "has been arriving",
      C: "arrives",
      D: "arrive",
    },
    correctAnswer: "C",
    explanation: "기차는 항상 (현재) 도착한다 ",
    translation: "기차는 항상 정시에 도착합니다, 항상 늦는 지역 열차와는 달리.",
    type: "present tense",
  },
  {
    id: 47,
    koreanQuestion:
      "목적은 이 회의 논의하기 위해서 전략에 대해 _____ 유통 요구를 중소기업.",
    question:
      "The objective of this meeting is to discuss strategies for ______ the distribution needs of small-to-medium-sized businesses.",
    choices: {
      A: "satisfaction",
      B: "to satisfy",
      C: "satisfying",
      D: "satisfied",
    },
    correctAnswer: "C",
    explanation: "for 충족시키는 것 유통 요구를",
    translation:
      "이 회의의 목적은 중소기업의 유통 요구를 충족시키는 전략에 대해 논의하는 것입니다.",
    type: "gerund",
  },
  {
    id: 48,
    koreanQuestion:
      "회의가 그.. 참여하는 모든 회사의 고위 임원들이 (현재) 조직되었습니다 ______ 그들이 진행할 수 있게 논의하는 것을 문제들을 제품 결함에 관한.",
    question:
      "A meeting involving all the company's senior executives has been organized ______ they can proceed to discuss issues regarding product defects.",
    choices: {
      A: "only",
      B: "in order",
      C: "because",
      D: "so that",
    },
    correctAnswer: "D",
    explanation:
      "A: '단지'라는 의미로, 이 문맥에서는 적절하지 않습니다. B: '~하기 위해서'라는 의미이지만, 'in order'만으로는 불완전한 표현입니다. 'in order to'나 'in order that'의 형태로 사용됩니다. C: '왜냐하면'이라는 이유를 나타내는 접속사로, 이 문맥에서는 적절하지 않습니다. D: '~하기 위해서'라는 목적을 나타내는 접속사로, 회의가 조직된 목적이 임원들이 제품 결함 문제를 논의할 수 있도록 하기 위함이라는 의미를 정확히 전달합니다.",
    translation:
      "회사의 모든 고위 임원들이 참여하는 회의가 그들이 제품 결함에 관한 문제들을 논의하기 위해 진행할 수 있도록 조직되었습니다.",
    type: "conjunctions",
  },
  {
    id: 49,
    koreanQuestion:
      "직원들 그... 배정될 일하도록 해외에서 권고됩니다 공부하도록 언어를 국가 안에서 그..그들이 거주할.",
    question:
      "Employees who will be assigned to work overseas are advised to study the language of the country in ______ they will reside.",
    choices: {
      A: "where",
      B: "when",
      C: "what",
      D: "which",
    },
    correctAnswer: "D",
    explanation:
      "A: '어디에'라는 의미의 관계부사로, 장소를 나타내지만 전치사 'in'이 이미 있으므로 적절하지 않습니다. B: '언제'라는 의미의 관계부사로, 시간을 나타내므로 이 문맥에서는 적절하지 않습니다. C: '무엇'이라는 의미의 관계대명사로, 이 문맥에서는 적절하지 않습니다. D: '어느/어떤'이라는 의미의 관계대명사로, 전치사 'in'과 함께 사용되어 '그 안에서'라는 의미를 나타내며, 직원들이 거주할 국가를 지칭합니다.",
    translation:
      "해외에서 근무하도록 배정될 직원들은 그들이 거주할 국가의 언어를 공부하도록 조언받습니다.",
    type: "relative pronouns",
  },
  {
    id: 50,
    koreanQuestion:
      "사용자들은 잊지 말아야 합니다 ______ 어떤 버전 소프트웨어가 설치되어 있는지 요청할 때 기술적 지원을 .",
    question:
      "Users should not forget ______ which version of the software is installed when requesting technical assistance.",
    choices: {
      A: "specifying",
      B: "specification",
      C: "to specify",
      D: "specify",
    },
    correctAnswer: "C",
    explanation:
      "'forget to do'(~하는 것을 잊다) 구조가 필요하므로 to부정사 형태인 'to specify'가 정답입니다.",
    translation:
      "사용자들은 기술적 지원을 요청할 때 어떤 버전의 소프트웨어가 설치되어 있는지 명시하는 것을 잊지 말아야 합니다.",
    type: "infinitive",
  },
];
